export const ADMIN_PACKS_REQUEST = 'ADMIN_PACKS_REQUEST'
export const ADMIN_PACKS_SUCCESS = 'ADMIN_PACKS_SUCCESS'
export const ADMIN_PACKS_FAIL = 'ADMIN_PACKS_FAIL'

export const ALL_PACKS_REQUEST = 'ALL_PACKS_REQUEST'
export const ALL_PACKS_SUCCESS = 'ALL_PACKS_SUCCESS'
export const ALL_PACKS_FAIL = 'ALL_PACKS_FAIL'

export const NEW_PACK_REQUEST = 'NEW_PACK_REQUEST'
export const NEW_PACK_SUCCESS = 'NEW_PACK_SUCCESS'
export const NEW_PACK_RESET = 'NEW_PACK_RESET'
export const NEW_PACK_FAIL = 'NEW_PACK_FAIL'

export const DELETE_PACK_REQUEST = 'DELETE_PACK_REQUEST'
export const DELETE_PACK_SUCCESS = 'DELETE_PACK_SUCCESS'
export const DELETE_PACK_RESET = 'DELETE_PACK_RESET'
export const DELETE_PACK_FAIL = 'DELETE_PACK_FAIL'

export const UPDATE_PACK_REQUEST = 'UPDATE_PACK_REQUEST'
export const UPDATE_PACK_SUCCESS = 'UPDATE_PACK_SUCCESS'
export const UPDATE_PACK_RESET = 'UPDATE_PACK_RESET'
export const UPDATE_PACK_FAIL = 'UPDATE_PACK_FAIL'

export const PACK_DETAILS_REQUEST = 'PACK_DETAILS_REQUEST'
export const PACK_DETAILS_SUCCESS = 'PACK_DETAILS_SUCCESS'
export const PACK_DETAILS_FAIL = 'PACK_DETAILS_FAIL'

export const NEW_REVIEW_REQUEST = 'NEW_REVIEW_REQUEST'
export const NEW_REVIEW_SUCCESS = 'NEW_REVIEW_SUCCESS'
export const NEW_REVIEW_RESET = 'NEW_REVIEW_RESET'
export const NEW_REVIEW_FAIL = 'NEW_REVIEW_FAIL'

export const GET_REVIEWS_REQUEST = 'GET_REVIEWS_REQUEST'
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS'
export const GET_REVIEWS_FAIL = 'GET_REVIEWS_FAIL'

export const DELETE_REVIEW_REQUEST = 'DELETE_REVIEW_REQUEST'
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS'
export const DELETE_REVIEW_RESET = 'DELETE_REVIEW_RESET'
export const DELETE_REVIEW_FAIL = 'DELETE_REVIEW_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'